import {useState} from "react"
import PropTypes from "prop-types"
import moment from "moment"
import Avatar from "@components/avatar"
import {Button, Spinner} from "reactstrap"
import img4 from "@src/assets/images/avatars/avatar-blank.png"
import {startRdSurvey} from "@src/views/rds/surveys/store/actions"

/**
 * S2B paid survey card, styled to match the Recommended Brand Outreach cards.
 * "Take survey" mints a single-use entry token and opens S2B in a new tab.
 */
const SurveyCard = ({survey}) => {
    const [starting, setStarting] = useState(false)
    const [error, setError] = useState(null)

    const handleStart = async () => {
        // Open the tab synchronously on click so popup blockers allow it;
        // it is pointed at S2B once the entry token comes back.
        const surveyTab = window.open("", "_blank")
        if (surveyTab) surveyTab.opener = null

        setStarting(true)
        setError(null)
        try {
            const url = await startRdSurvey(survey?.survey_id)
            if (!url) throw new Error("No survey URL returned")
            if (surveyTab) {
                surveyTab.location.href = url
            } else {
                window.location.assign(url)
            }
        } catch (e) {
            if (surveyTab) surveyTab.close()
            setError("We couldn't open this survey. Please try again.")
        } finally {
            setStarting(false)
        }
    }

    return (
        <div
            className="full-height brandContent text-center p-3 d-flex flex-column justify-content-between"
            style={{
                position: 'relative',
                backgroundColor: '#ffffff',
                border: '1px solid #EAEAEA',
                borderRadius: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.03)'
            }}
        >
            {survey?.incentive_amount && (
                <div
                    style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        zIndex: 2,
                        backgroundColor: '#EAF3DE',
                        color: '#27500A',
                        borderRadius: '9999px',
                        padding: '4px 12px',
                        fontSize: '12px',
                        fontWeight: 600,
                        lineHeight: 1
                    }}
                >
                    {survey.incentive_amount} reward
                </div>
            )}
            <div className="d-flex flex-column align-items-center w-100">
                <Avatar img={survey?.brand_img || img4} imgHeight="72" imgWidth="72" className="avatar-img-fit-contain mt-1 mb-2"/>
                {survey?.brand_name && (
                    <div className="text-muted mb-50" style={{fontSize: "13px"}}>{survey.brand_name}</div>
                )}
                <h4 className="text-break font-weight-bold text-center mb-1" title={survey?.title} style={{color: "#111111", fontSize: "16px", lineHeight: "1.3"}}>
                    {survey?.title?.length > 40 ? `${survey.title.substring(0, 40)}...` : survey?.title}
                </h4>
                {survey?.end_date && (
                    <div className="text-muted mb-1" style={{fontSize: "12px"}}>
                        Ends {moment(survey.end_date).format("MMM D, YYYY")}
                    </div>
                )}
            </div>
            <div className="w-100 mt-1">
                <Button color="none" className="w-100 outreach-btn-apply" onClick={handleStart} disabled={starting}>
                    {starting ? <Spinner size="sm"/> : "Take survey"}
                </Button>
                {error && <div className="text-danger mt-50" style={{fontSize: "12px"}}>{error}</div>}
            </div>
        </div>
    )
}

SurveyCard.propTypes = {
    survey: PropTypes.shape({
        survey_id: PropTypes.string.isRequired,
        title: PropTypes.string,
        incentive_amount: PropTypes.string,
        end_date: PropTypes.string,
        brand_name: PropTypes.string,
        brand_img: PropTypes.string
    }).isRequired
}

export default SurveyCard
